import {
  addDays,
  format,
  isBefore,
  parseISO,
  startOfDay,
  startOfWeek
} from "date-fns";
import { zhCN } from "date-fns/locale";

export const APP_TIME_ZONE = "Asia/Shanghai";

export function nowIso(): string {
  return new Date().toISOString();
}

export function localDateKey(date = new Date()): string {
  return format(date, "yyyy-MM-dd");
}

export function getMondayKey(date = new Date()): string {
  return format(startOfWeek(date, { weekStartsOn: 1 }), "yyyy-MM-dd");
}

export function addLocalDays(dateKey: string, amount: number): string {
  return format(addDays(parseISO(`${dateKey}T12:00:00`), amount), "yyyy-MM-dd");
}

export function formatChineseDate(date = new Date()): string {
  return format(date, "M月d日 EEEE", { locale: zhCN });
}

export function formatShortDate(value?: string): string {
  if (!value) return "未设置";
  return format(parseISO(value.length === 10 ? `${value}T12:00:00` : value), "M月d日");
}

export function formatDateTime(value?: string): string {
  if (!value) return "未设置";
  return format(parseISO(value), "M月d日 HH:mm");
}

export function dateInputValue(value?: string): string {
  if (!value) return "";
  return value.slice(0, 10);
}

export function dateAtLocalNoon(value?: string): string | undefined {
  if (!value) return undefined;
  return `${value}T12:00:00+08:00`;
}

export function isTaskDue(taskDueAt?: string, date = new Date()): boolean {
  if (!taskDueAt) return false;
  const due = parseISO(taskDueAt.length === 10 ? `${taskDueAt}T23:59:59` : taskDueAt);
  return isBefore(startOfDay(due), startOfDay(date));
}

export function isReviewDue(reviewAt?: string, date = new Date()): boolean {
  if (!reviewAt) return false;
  return isBefore(parseISO(reviewAt.length === 10 ? `${reviewAt}T23:59:59` : reviewAt), date);
}

export function isFollowUpDue(followUpAt?: string, date = new Date()): boolean {
  if (!followUpAt) return false;
  return isBefore(parseISO(`${followUpAt}T23:59:59`), date);
}

export function weekEndKey(weekStart: string): string {
  return addLocalDays(weekStart, 6);
}

export function relativeDayLabel(dateKey?: string): string {
  if (!dateKey) return "未设置";
  const today = localDateKey();
  if (dateKey === today) return "今天";
  if (dateKey === addLocalDays(today, 1)) return "明天";
  if (dateKey === addLocalDays(today, -1)) return "昨天";
  return formatShortDate(dateKey);
}
